import React, { useCallback, useEffect, useState } from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import Button from '../../../../elements/Button/Button';
import Modal from '../../../../elements/Modal';
import LeadRecord from '../../../UserProfile/LeadRecord';
import { LEADS_TAB_MINE } from '../../tabs';
import styles from './NewLeadModal.module.scss';

function NewLeadModal(props) {
    const { event, lead, onClose } = props,
        [editable, setEditable] = useState(false),
        fullProfileHref = ['/events', event.id, 'leads', LEADS_TAB_MINE, lead?.sponsor_id, 'participant', '-', lead?.participant_id].join('/'),
        i18n = useI18n();

    useEffect(() => {
        setEditable(false);
    }, [lead]);

    const handleTurnEditable = useCallback(() => setEditable(true), []);

    return (
        <Modal show={!!lead} fullScreen={false} onClose={onClose}>
            {lead ? <LeadRecord className="content" event={event} user={lead?.participant} sponsorId={lead.sponsor_id} showName editable={editable} /> : null}
            {!editable ? (
                <div className={styles.buttonsWrapper}>
                    <Button className="primary outline" onClick={handleTurnEditable}>
                        {i18n['label.add-note']}
                    </Button>
                    <Button className="primary outline" href={fullProfileHref}>
                        {i18n['label.view-full-profile']}
                    </Button>
                </div>
            ) : null}
        </Modal>
    );
}

export default NewLeadModal;
